import { createVNode as _createVNode, withModifiers as _withModifiers, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";

var _hoisted_1 = /*#__PURE__*/_createVNode("div", {
  class: "modal-overlay"
}, null, -1);

var _hoisted_2 = {
  class: "modal-container"
};
var _hoisted_3 = {
  key: 0,
  class: "modal-header"
};
var _hoisted_4 = {
  class: "modal-title"
};
var _hoisted_5 = {
  key: 1,
  class: "modal-body"
};
var _hoisted_6 = {
  class: "content1"
};
var _hoisted_7 = {
  class: "modal-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createBlock("div", {
    class: ["modal", {
      active: _ctx.show
    }],
    role: "dialog",
    "aria-modal": "true",
    key: _ctx.key
  }, [_hoisted_1, _createVNode("div", _hoisted_2, [_ctx.showTitle ? (_openBlock(), _createBlock("div", _hoisted_3, [_createVNode("a", {
    href: "",
    onClick: _cache[1] || (_cache[1] = _withModifiers(function ($event) {
      return _ctx.close();
    }, ["prevent"])),
    class: "btn btn-clear float-right",
    "aria-label": "Close"
  }), _createVNode("div", _hoisted_4, [_renderSlot(_ctx.$slots, "title")])])) : _createCommentVNode("", true), _ctx.showBody ? (_openBlock(), _createBlock("div", _hoisted_5, [_createVNode("div", _hoisted_6, [_renderSlot(_ctx.$slots, "body", {
    key: _ctx.show
  })])])) : _createCommentVNode("", true), _createVNode("div", _hoisted_7, [_renderSlot(_ctx.$slots, "footer")])])], 2);
}